module.exports = __webpack_public_path__ + "static/media/photo-1518176258769-f227c798150e.0d25308c.jpg";